import { render, staticRenderFns } from "./VehicleDriverModal.vue?vue&type=template&id=4aae3990&scoped=true"
import script from "./VehicleDriverModal.vue?vue&type=script&lang=js"
export * from "./VehicleDriverModal.vue?vue&type=script&lang=js"
import style0 from "./VehicleDriverModal.vue?vue&type=style&index=0&id=4aae3990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae3990",
  null
  
)

export default component.exports